import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReturn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 11,
	viewBox: "0 0 15 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.00001 5L12 5C12.9428 5 13.4142 5 13.7071 5.29289C14 5.58579 14 6.05719 14 7V10M1.00001 5L4.51352 1M1.00001 5L4.51352 9",
		stroke: "#424242",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgReturn;
